export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:chunkError', () => {
        window.location.reload()
    });
    window.addEventListener('error', (event) => {
        if (event.message?.includes('Failed to fetch dynamically imported module')) {
            window.location.reload(true)
        }
        if (event.message?.includes('reopenBookmarklet') ||
            event.message?.includes('bookmarklet') ||
            event.filename?.includes('extension://') ||
            event.filename?.includes('chrome-extension://')) {
            event.preventDefault()
            return false
        }
    })
})